import { orderBy, concat, map, filter, values } from 'lodash';
import {
  GET_ALL_API_KEYS_SUCCESS,
  DELETE_API_KEY_SUCCESS,
  LOGOUT_COMPLETE,
} from '../../constants/actionTypes';

const initialState = {
  lastUpdated: null,
  sortedIds: [],
};

export const apiKeysReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_API_KEYS_SUCCESS:
      return saveAPIKeys(state, action);

    case DELETE_API_KEY_SUCCESS:
      return deleteAPIKey(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

export default apiKeysReducer;

function saveAPIKeys(state, action) {
  const {
    entities: { apiKeys },
    result,
  } = action;
  const sortedIds = orderBy(
    concat(...map(values(result), 'id')),
    [(id) => apiKeys[id].created_at],
    ['desc'],
  );

  return {
    ...state,
    lastUpdated: action.receivedAt,
    sortedIds,
  };
}

function deleteAPIKey(state, action) {
  const {
    requestInfo: { id: deletedId },
  } = action;
  const { sortedIds } = state;
  const newSortedIds = filter(sortedIds, (id) => id !== deletedId);

  return {
    ...state,
    lastUpdated: action.receivedAt,
    sortedIds: newSortedIds,
  };
}
